import React from 'react'
import Grid from '@material-ui/core/Grid'
import { JurisdictionType, WageAmount, WageAmountLabel } from './detail/styles'
import { formatCurrency } from '../../common/helpers'


const standardWageFragment = function (jurisdiction, jurisdictionType) {
  return (
    <React.Fragment>
      <Grid item xs={2}>
        <WageAmount>{formatCurrency(jurisdiction.standard.wage)}</WageAmount>
      </Grid>
      <Grid item xs>
        <WageAmountLabel>Minimum Wage</WageAmountLabel>
        <JurisdictionType>{jurisdictionType}</JurisdictionType>
      </Grid>
    </React.Fragment>
  )
}

export default function StandardWage({ jurisdiction, jurisdictionType }) {
  if (jurisdiction.standard && jurisdiction.standard.wage) {
    return standardWageFragment(jurisdiction, jurisdictionType)
  }
  return null
}
